var map = {
	"./Base": 493,
	"./Base/": 493,
	"./Base/index": 493,
	"./Base/index.js": 493,
	"./Clutch": 558,
	"./Clutch/": 558,
	"./Clutch/OverridePrivate": 1390,
	"./Clutch/OverridePrivate.js": 1390,
	"./Clutch/Private": 1389,
	"./Clutch/Private.js": 1389,
	"./Clutch/Public": 1391,
	"./Clutch/Public.js": 1391,
	"./Clutch/index": 558,
	"./Clutch/index.js": 558,
	"./Clutch/privateStyle": 165,
	"./Clutch/privateStyle.js": 165,
	"./Clutch/publicStyle": 1075,
	"./Clutch/publicStyle.js": 1075,
	"./NewUi": 559,
	"./NewUi/": 559,
	"./NewUi/Private": 1392,
	"./NewUi/Private.js": 1392,
	"./NewUi/Public": 1393,
	"./NewUi/Public.js": 1393,
	"./NewUi/index": 559,
	"./NewUi/index.js": 559,
	"./NewUi/privateStyle": 514,
	"./NewUi/privateStyle.js": 514,
	"./NewUi/publicStyle": 853,
	"./NewUi/publicStyle.js": 853,
	"./OldUi": 560,
	"./OldUi/": 560,
	"./OldUi/Private": 1394,
	"./OldUi/Private.js": 1394,
	"./OldUi/Public": 1395,
	"./OldUi/Public.js": 1395,
	"./OldUi/index": 560,
	"./OldUi/index.js": 560,
	"./OldUi/privateStyle": 478,
	"./OldUi/privateStyle.js": 478,
	"./OldUi/publicStyle": 854,
	"./OldUi/publicStyle.js": 854,
	"./SpireonNew": 561,
	"./SpireonNew/": 561,
	"./SpireonNew/Private": 1396,
	"./SpireonNew/Private.js": 1396,
	"./SpireonNew/Public": 1397,
	"./SpireonNew/Public.js": 1397,
	"./SpireonNew/index": 561,
	"./SpireonNew/index.js": 561,
	"./SpireonNew/privateStyle": 1015,
	"./SpireonNew/privateStyle.js": 1015,
	"./SpireonNew/publicStyle": 855,
	"./SpireonNew/publicStyle.js": 855,
	"./SpireonOld": 562,
	"./SpireonOld/": 562,
	"./SpireonOld/Private": 1398,
	"./SpireonOld/Private.js": 1398,
	"./SpireonOld/Public": 1399,
	"./SpireonOld/Public.js": 1399,
	"./SpireonOld/index": 562,
	"./SpireonOld/index.js": 562,
	"./SpireonOld/privateStyle": 856,
	"./SpireonOld/privateStyle.js": 856,
	"./SpireonOld/publicStyle": 857,
	"./SpireonOld/publicStyle.js": 857
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 7568;
module.exports = webpackAsyncContext;